const FormFieldType = Object.freeze({
  TEXT_FIELD: 'TEXT_FIELD',
  DATE: 'DATE',
  DATETIME: 'DATETIME',
  SELECT: 'SELECT',
  TEXT_AREA: 'TEXT_AREA',
  SELECT_CHIP: 'SELECT_CHIP',
  CHECKBOX: 'CHECKBOX'
});

export default FormFieldType;
